/* 2026-10-19 success animations, toned down (Mihai v2): subtle check-pops and soft shine only, short and small.
   window.hpCelebrate: confetti(target, opts) · pop(el) · shine(el) · check(el) · countUp(el, to) · tick() · success(el)
   Wired with observers (sections not edited): PDP plan picked (pop + soft shine on the buy button), scratch final reveal
   (count-up + pop; the fan's own small burst is the only confetti) + email captured (pop) + CLAIM shine, quiz result (pop), Shopify form success (check + pop).
   No confetti on the product page or on buy taps. prefers-reduced-motion: no movement. Nothing here touches links, checkout or tracking. */
(function () {
  var rm = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var COLORS = ['#9B2236', '#FAF4EC', '#D9B45A', '#9B2236', '#ECD287'];
  var lastTick = 0;
  var shineTimers = new WeakMap();
  function tick(p) { var n = Date.now(); if (n - lastTick < 120 || !navigator.vibrate) return; lastTick = n; try { navigator.vibrate(p || 12); } catch (e) {} }
  function center(t) {
    if (t && typeof t.x === 'number') return t;
    var r = t.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }
  function confetti(target, o) {
    if (rm.matches || !target) return;
    o = o || {};
    var host = (target.closest && target.closest('dialog[open]')) || document.body;
    var c = document.createElement('canvas'); c.className = 'hp-cel-canvas'; c.setAttribute('aria-hidden', 'true');
    var dpr = Math.min(devicePixelRatio || 1, 2), W = innerWidth, H = innerHeight;
    c.width = W * dpr; c.height = H * dpr; host.appendChild(c);
    var x = c.getContext('2d'); if (!x) { c.remove(); return; } x.setTransform(dpr, 0, 0, dpr, 0, 0);
    var p0 = center(target), n = o.count || 70, pow = o.power || 9, ps = [];
    for (var i = 0; i < n; i++) {
      var a = (o.up ? -Math.PI / 2 : 0) + (o.up ? (Math.random() - .5) * Math.PI * .9 : Math.random() * Math.PI * 2), s = pow * (.45 + Math.random() * .75);
      ps.push({ x: p0.x, y: p0.y, vx: Math.cos(a) * s, vy: Math.sin(a) * s - (o.up ? 2 : 3), w: 6 + Math.random() * 6, h: 4 + Math.random() * 6, r: Math.random() * 6, vr: (Math.random() - .5) * .4, c: COLORS[i % COLORS.length], round: i % 4 === 0, life: 1 });
    }
    var t0 = performance.now(), dur = o.duration || 1500;
    (function f(now) {
      var k = (now - t0) / dur; x.clearRect(0, 0, W, H);
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i]; p.vy += .32; p.vx *= .985; p.vy *= .985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        x.save(); x.globalAlpha = Math.max(0, 1 - Math.max(0, k - .6) / .4); x.translate(p.x, p.y); x.rotate(p.r); x.fillStyle = p.c;
        if (p.round) { x.beginPath(); x.arc(0, 0, p.h / 2 + 1, 0, 6.283); x.fill(); } else x.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        if (p.c === '#FAF4EC') { x.strokeStyle = 'rgba(155,34,54,.35)'; x.lineWidth = .8; if (p.round) x.stroke(); else x.strokeRect(-p.w / 2, -p.h / 2, p.w, p.h); }
        x.restore();
      }
      if (k < 1) requestAnimationFrame(f); else c.remove();
    })(t0);
  }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  function pop(el) { if (!el || rm.matches) return; restart(el, 'hp-cel-pop'); setTimeout(function () { el.classList.remove('hp-cel-pop'); }, 400); }
  function shine(el) {
    if (!el || rm.matches) return;
    clearTimeout(shineTimers.get(el));
    if (getComputedStyle(el).position === 'static') el.classList.add('hp-cel-shine-pos');
    restart(el, 'hp-cel-shine');
    shineTimers.set(el, setTimeout(function () { el.classList.remove('hp-cel-shine', 'hp-cel-shine-pos'); shineTimers.delete(el); }, 700));
  }
  function check(el) {
    if (!el || el.querySelector(':scope > .hp-cel-check') || (el.previousElementSibling && el.previousElementSibling.classList.contains('hp-cel-check'))) return;
    var b = document.createElement('span'); b.className = 'hp-cel-check'; b.setAttribute('aria-hidden', 'true');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var wrap = document.createElement('div'); wrap.style.textAlign = 'center'; wrap.appendChild(b); el.parentNode.insertBefore(wrap, el);
  }
  // count the first number in el up to its value (e.g. "$40 OFF": $0 -> $40)
  function countUp(el, dur) {
    if (!el) return; var m = el.textContent.match(/(\d+)/); if (!m) return;
    var to = +m[1], tpl = el.textContent; if (rm.matches) return;
    var t0 = performance.now(); dur = dur || 700;
    (function f(n) { var k = Math.min(1, (n - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = tpl.replace(m[1], String(Math.round(to * e))); if (k < 1) requestAnimationFrame(f); else el.textContent = tpl; })(t0);
  }
  function success(el) { if (!el) return; check(el); pop(el); tick(10); }
  window.hpCelebrate = { confetti: confetti, pop: pop, shine: shine, check: check, countUp: countUp, tick: tick, success: success };

  // watch an element for a class (or for losing [hidden]) and run fn once per change
  function onClass(el, cls, fn) { if (!el) return; var had = el.classList.contains(cls); new MutationObserver(function () { var has = el.classList.contains(cls); if (has && !had) fn(el); had = has; }).observe(el, { attributes: true, attributeFilter: ['class'] }); }
  function onShown(el, fn) { if (!el) return; var was = el.hidden; new MutationObserver(function () { if (was && !el.hidden) fn(el); was = el.hidden; }).observe(el, { attributes: true, attributeFilter: ['hidden'] }); }

  function init() {
    // --- PDP: plan picked (subtle pop on the card + soft shine on the buy button; no confetti on the product page)
    var pdp = document.getElementById('hp-lrx');
    if (pdp) {
      var planMotions = new WeakMap();
      pdp.addEventListener('lx:planchange', function (event) {
        var plan = event.detail.plan;
        var previousMotion = planMotions.get(plan);
        var from = previousMotion ? getComputedStyle(plan).transform : 'none';
        if (previousMotion) { previousMotion.cancel(); planMotions.delete(plan); }
        if (!rm.matches && plan.animate) {
          var motion = plan.animate([
            { transform: from === 'none' ? 'scale(.985)' : from },
            { transform: 'scale(1.015)', offset: .5 },
            { transform: 'scale(1)' }
          ], { duration: 320, easing: 'cubic-bezier(.34,1.4,.64,1)' });
          planMotions.set(plan, motion);
          motion.onfinish = function () { if (planMotions.get(plan) === motion) planMotions.delete(plan); };
        }
        tick(10);
        shine(pdp.querySelector('[data-lx-atc]'));
      });
      function stopPlanMotion() {
        if (!rm.matches) return;
        pdp.querySelectorAll('[data-lx-plan]').forEach(function (plan) {
          var motion = planMotions.get(plan);
          if (motion) { motion.cancel(); planMotions.delete(plan); }
        });
      }
      if (rm.addEventListener) rm.addEventListener('change', stopPlanMotion);
    }
    // --- scratch pop-up: count-up + pop on the final reveal (the fan's own small, brief burst in her-part-scratch.js is the only confetti on the site)
    var sc = document.getElementById('hpScratch');
    if (sc) {
      var fan = sc.querySelector('[data-scratch-ticket]');
      onClass(fan, 'is-revealed', function () {
        var off = sc.querySelector('[data-scratch-card][data-prize="off"]') || fan;
        setTimeout(function () { countUp(off.querySelector('.hp-scratch__prize-offer'), 500); pop(off.querySelector('.hp-scratch__pz--off')); }, 380);
      });
      onShown(sc.querySelector('[data-scratch-success]'), function (el) { pop(el.querySelector('.hp-scratch__mail')); tick(10); });
      sc.querySelectorAll('[data-scratch-continue]').forEach(function (b) { onClass(b, 'is-visible', function () { setTimeout(function () { shine(b); }, 450); }); });
    }
    // --- quiz result: subtle pop on the result label
    onShown(document.querySelector('.hp-quiz-result[data-screen="result"]'), function (el) { pop(el.querySelector('.hp-quiz-result-label') || el); tick(10); });
    // --- Shopify form success messages (newsletter, contact): check badge + pop
    document.querySelectorAll('.form__message .icon-success, .newsletter-form__message--success, .form-status-list + .form__message, [data-hp-success]').forEach(function (n) {
      var el = n.closest('.form__message, .newsletter-form__message, [data-hp-success]') || n; setTimeout(function () { success(el); }, 300);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
